module.exports = __webpack_public_path__ + "img/avatar-62.be64c703.png";